/*  MUI  */
import {
    Check,
    Close,
    DomainDisabled, // Login,
    PlayDisabled
} from '@mui/icons-material';
import {
    Box,
    Button,
    Checkbox,
    Grid,
    Paper,
    TableCell,
    Typography
} from '@mui/material';

/*  Shared  */
import { DateFormat } from 'application/Shared/Components/Core';
import { ManagedTable } from 'application/Shared/Components/Table';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import {
    Notify, // Response,
    Transition
} from 'application/Shared/Helpers';
import { Modal, ModalBody, ModalFooter } from 'application/Shared/Modals';
import { Requests } from 'application/Shared/Requests';
// import { debug } from 'application/Shared/Utils';
import { GlobalView } from 'application/Shared/Views';

/*  NPM  */
import axios from 'axios';
import i18n from 'i18n';

/*  Objects  */
// import Session from 'objects/Session';
import { User, UserEmail, UserFromContext } from 'objects/User';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Constants  */
// const { hasResponseData, getResponseData } = Response;

const headers = [
    {
        field: 'name',
        renderHeader: i18n.t('Common.name'),
        width: '20%'
    },
    {
        field: 'id',
        renderHeader: i18n.t('Common.id'),
        width: '15%'
    },
    {
        field: 'email',
        renderHeader: i18n.t('Common.email'),
        width: '20%'
    },
    {
        renderHeader: i18n.t('Common.tenant'),
        width: '20%'
    },
    {
        align: 'center',
        renderHeader: i18n.t('Common.enabled'),
        width: '5%'
    },
    {
        renderHeader: i18n.t('Common.dateAdded'),
        width: '10%'
    },
    {
        align: 'right',
        renderHeader: i18n.t('Common.actions'),
        width: '10%'
    }
];

const parameters = {
    global: true,
    ignoreDisabled: true,
    includeTenant: true
};

const searchFields = [
    'id',
    'name',
    'email',
    'title',
    'tenant.name',
    'tenant.id'
];

class GlobalUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: { blocked: false, id: 0 },
            viewingUser: false
        };

        /* requests */
        this.requests = new Requests();
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        this.requests.cancel();
    };

    // @TODO Refactor login method after resolving https://auviknetworks.atlassian.net/browse/SAAS-1115
    // login = async (id) => {
    //     try {
    //         // NOTE: this endpoint has been changed to return HttpOnly cookie for refreshToken.
    //         // However, it is restricted to /api/authenticate prefix -- so this will not work w/o changes
    //         // Also our setupProxy.js does not allwo for `withCredentials` to send cookie as currently setup
    //         const response = await axios.get(`/user/${id}/jwt`, {
    //             cancelToken: this.requests.token(),
    //             withCredentials: true,
    //         });
    //         if (!hasResponseData(response)) {
    //             Notify.e('Error Logging in as User');
    //             return;
    //         }

    //         const data = getResponseData(response);
    //         const { jwt } = data;

    //         await Session.storeJWT(jwt, () => {
    //             // Broadcast to reload other tabs/windws
    //             this.context.sendMessage('pageReload');
    //             debug.dev('Successfully stored user JWT', jwt);
    //             window.location = '/home';
    //         });
    //     } catch (e) {
    //         debug.e('Caught Error on User Login', e);
    //         Notify.e(e.response.data.message);
    //     }
    // };

    save = async () => {
        const { user } = this.state;
        const { id, blocked } = user;
        try {
            await axios.put(`/user/${id}`, { blocked, global: true });

            Notify.s('Successfully saved user.');
            this.setState({ viewingUser: false });
            this.rerender();
        } catch (e) {
            Notify.e(e.toString());
        }
    };

    open = (user) => {
        this.setState({ user, viewingUser: true });
    };

    rerender = () => {
        this.setState({ rerender: true }, () =>
            this.setState({ rerender: false })
        );
    };

    renderSaveModal() {
        const { t } = this.props;
        const { viewingUser, user } = this.state;

        if (!viewingUser) {
            return null;
        }

        const { blocked } = user;

        return (
            <>
                <ModalBody dividers>
                    <Box display="flex" alignItems="center">
                        <Typography
                            variant="span"
                            color="textSecondary"
                            fontWeight={600}
                        >
                            {t('Common.editing_user')}:{' '}
                        </Typography>
                        <Typography marginLeft="4px">{user.name}</Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <Typography
                            variant="span"
                            color="textSecondary"
                            fontWeight={600}
                        >
                            Blocked:
                        </Typography>
                        <Checkbox
                            checked={blocked}
                            onChange={() =>
                                this.setState({
                                    user: { ...user, blocked: !blocked }
                                })
                            }
                        />
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button
                        data-trackid="globalAdmin_user_saveModal_cancel"
                        onClick={() => this.setState({ viewingUser: false })}
                        variant="outlined"
                        color="primary"
                        style={{ marginRight: '8px' }}
                    >
                        {t('Common.cancel')}
                    </Button>
                    <Button
                        data-trackid="globalAdmin_user_saveModal_save"
                        onClick={() => this.save()}
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: 'auto' }}
                    >
                        {t('Common.save')}
                    </Button>
                </ModalFooter>
            </>
        );
    }

    renderActions(row) {
        const { t } = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Button
                        data-trackid="globalAdmin_user_edit"
                        onClick={() => this.open(row)}
                        color="primary"
                        variant="contained"
                        size="small"
                    >
                        {t('Common.edit')}
                    </Button>
                </Grid>
                {/* Commenting out until https://auviknetworks.atlassian.net/browse/SAAS-1115 */}
                {/* <Grid item xs={12}>
                    <Button
                        data-trackid="globalAdmin_user_loginAs"
                        onClick={() => this.login(row.id)}
                        color="primary"
                        variant="contained"
                        size="small"
                    >
                        {t('Common.login')}
                        <Login
                            style={{
                                fontSize: FontSizes[1],
                                marginLeft: '4px'
                            }}
                        />
                    </Button>
                </Grid> */}
            </Grid>
        );
    }

    renderRow = (row) => {
        const { t } = this.props;
        const { id, disabled, dateAdded, dateCreated, tenant } = row;

        const userBlocked = row.blocked;
        const tenantBlocked = tenant.blocked;

        let tenantName = tenant.name;
        if (!tenant.name) {
            tenantName = t('Common.n/a');
        }

        return (
            <User data={row}>
                <TableCell>
                    <Box display="flex">
                        {userBlocked && (
                            <TooltipQ
                                text="Blocked at the user-level"
                                content={
                                    <PlayDisabled
                                        sx={{
                                            color: 'icon.primary',
                                            marginRight: '4px'
                                        }}
                                    />
                                }
                            />
                        )}
                        {tenantBlocked && (
                            <TooltipQ
                                text="Blocked at the tenant-level"
                                content={
                                    <DomainDisabled
                                        sx={{
                                            color: 'icon.primary',
                                            marginRight: '4px'
                                        }}
                                    />
                                }
                            />
                        )}
                        <UserFromContext noTruncate />
                    </Box>
                </TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>
                    <UserEmail />
                </TableCell>
                <TableCell>
                    <>
                        {tenantName}
                        <br />
                        <small>{tenant.id}</small>
                    </>
                </TableCell>
                <TableCell>
                    {!disabled ? (
                        <Check
                            fontSize="small"
                            sx={{ color: 'icon.success' }}
                        />
                    ) : (
                        <Close fontSize="small" sx={{ color: 'icon.error' }} />
                    )}
                </TableCell>
                <TableCell>
                    <DateFormat date={dateAdded || dateCreated} noTz />
                </TableCell>
                <TableCell align="right">{this.renderActions(row)}</TableCell>
            </User>
        );
    };

    render() {
        const { t } = this.props;
        const { viewingUser, rerender } = this.state;

        return (
            <GlobalView page="globalAdminUsers">
                <Paper elevation={0} variant="outlined" style={{ padding: 20 }}>
                    <ManagedTable
                        handleSearchChange
                        headers={headers}
                        parameters={parameters}
                        renderBody={this.renderRow}
                        renderBodyKey="id"
                        rerender={rerender}
                        rowsApi="/user"
                        rowsApiPreload
                        rowsPerPage={10}
                        searchEnabled
                        searchFields={searchFields}
                        sortDirection="DESC"
                        sortFieldType="date"
                        sortKey="dateCreated"
                        renderFooter
                    />
                </Paper>
                {viewingUser && (
                    <Modal
                        open={viewingUser}
                        aria-labelledby="simple-dialog-title"
                        TransitionComponent={Transition}
                        onClose={(_event, reason) => {
                            if (reason === 'backdropClick') {
                                this.setState({ viewingUser: false });
                            }
                        }}
                        fullWidth
                        title={t('Common.edit_user')}
                    >
                        {this.renderSaveModal()}
                    </Modal>
                )}
            </GlobalView>
        );
    }
}

export default withTranslation()(GlobalUser);
